export default{
    InvoiceMent:{
        Headers:{
            title:"账期支付的订单将在账期结算时统一开具发票，该页面的数据均不包含账期支付",
            title1:"可开票金额",
            invoTitle:"发票抬头",
            title2:"开票记录",

        },
        form:{
            query:"订单号",
            invoApplyStatus:"发票状态",
            datepicker:"申请时间",
        },
        placeholder:{
            query:"请输入订单编号",
            invoApplyStatus:"全部",
            datepicker:["开始时间","结束时间"],
        },
        Message:{
               zqjsd:"账期结算单逾期",
               zqjsd1:"天收取账期结算金额的",
               zqjsd2:"%作为滞纳金",
        },
        Alert:{

        },
        Button:{
            goInvo:'去开票',
            btnInvoTile:"管理发票抬头",
            btnSeach:"搜索",
            btnReset:"重置",
            btnDetail:"查看详情",
            btnConfirm:"确定"
        },
        Placeholder:{

        },
        Validate:{

        },
        tooltip:{
            content:"可开票金额=总计消费可开票金额-历史已开票金额"
        },
        Description:{
            noData:'暂无发票',
            emptyText:"暂无数据"
        },
        Table:{
            headerName:['申请时间','发票类型','收票主体','发票抬头','开票主体','订单号','发票金额','状态','操作'],
        }
    }
    
}